<app-tab-button (onClick)="toggleSort()" [icon]="faSortAmountUpAlt" label="SORT">
</app-tab-button>
<div appDisableBodyScroll class="sort-dialog" (click)="toggleSort()" *ngIf="showSortPopup">
  <div (click)="$event.stopPropagation()" class="sort-dialog-content">
    <div class="d-flex justify-content-between">
      <p class="mb-0"><b>SORT BY</b></p>
      <fa-icon (click)="toggleSort()" [icon]="faTimes"></fa-icon>
    </div>
    <hr>
    <app-sort-content (applySortEvent)="toggleSort()"></app-sort-content>
  </div>
</div>